/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  /* Javascript - Show cart drawer when product added to cart */
  /* This is the chunk of code that causes the issue with Infinite Options but is needed for full drawer */
  document.addEventListener('theme:cart:popdown', (e) => {
    const listener = (e) => {
      document.querySelector('[data-drawer="drawer-cart"]').dispatchEvent(
        new CustomEvent('theme:drawer:open', {
          bubbles: false,
        })
      );
      document.removeEventListener('theme:cart:change', listener);
    };
    document.addEventListener('theme:cart:change', listener);
  });
  /* end */
    
  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      //console.log('Container ———————— ↓');
      //console.log(container);
      //console.log('Variant —————————— ↓');
      //console.log(variant);
      // ... update some element on the page

      if (variant.compare_at_price){
      var strikethroughamt = document.getElementById("strikethroughamt");
      var compare_at_price = variant.compare_at_price + '';
      strikethroughamt.innerHTML = '$' + compare_at_price.substring(0, compare_at_price.length - 2);
      }
    }
    
    //Klaviyo Back in Stock button show or hide based on variant
    if (variant) {    
      var klaviyobis = document.getElementById("klaviyobisbutton");
      if (variant.available == true) {
        klaviyobis.style.display="none";
      }
      if (variant.available == false) {
        klaviyobis.style.display="flex";
      }    
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      //console.log('Cart ———————————— ↓');
      //console.log(cart);
      // ... update an app or a custom shipping caluclator

      var gwp_on_off = true;
      var gwp_promo_amount = 20000;        

      if (gwp_on_off == true){
        const gwp_message = document.getElementById("gwp_message");
        const gwp_cart_message = document.getElementById("gwp_cart_message");      
        if (cart.total_price >= gwp_promo_amount) {
                console.log('Cart Over 200');
  
                if (gwp_message !== null) {
                  document.getElementById("gwp_message").style.display="flex";
                }
                if (gwp_cart_message !== null) {
                  document.getElementById("gwp_cart_message").style.display="flex";        
                }
        }
        if (cart.total_price < gwp_promo_amount) {
                console.log('Cart Under 200');
  
                if (gwp_message !== null) {        
                  document.getElementById("gwp_message").style.display="none";
                }
                if (gwp_cart_message !== null) {        
                  document.getElementById("gwp_cart_message").style.display="none"; 
                }
        }      
      }

      var shipping_promo_on_off = true;
      var shipping_promo_amount = 200;      

      if (shipping_promo_on_off == true){
        const shipping_promo_message = document.getElementById("shipping_promo_message");
        const shipping_promo_cart_message = document.getElementById("shipping_promo_cart_message");      
        if (cart.total_price >= (shipping_promo_amount * 100)) {
                console.log('Cart Over 200');
  
                if (shipping_promo_message !== null) {
                  document.getElementById("shipping_promo_message").style.display="flex";
                }
                if (shipping_promo_cart_message !== null) {
                  document.getElementById("shipping_promo_cart_message").style.display="flex";        
                }
        }
        if (cart.total_price < (shipping_promo_amount * 100)) {
                console.log('Cart Under 200');
  
                if (shipping_promo_message !== null) {        
                  document.getElementById("shipping_promo_message").style.display="none";
                }
                if (shipping_promo_cart_message !== null) {        
                  document.getElementById("shipping_promo_cart_message").style.display="none"; 
                }
        }      
      }      
      
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    //console.log('theme:cart:init');
    //console.log(e);


  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  //document.addEventListener('theme:scroll', e => { console.log(e); });
  //document.addEventListener('theme:scroll:up', e => { console.log(e); });
  //document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  //document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));

  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();

